import { combineReducers } from 'redux';
import drawerOpen from './drawerOpen';
import headerMenu from './headerMenu';

export default combineReducers({
  drawerOpen,
  headerMenu,
});
